// import { takeLatest, all, call, put } from 'redux-saga/effects';
import { takeLatest, all, call, put } from 'typed-redux-saga/macro'; // allows us to use the typed version of each of these effect creator (takeLatest, all, call, put)
import { getCatogoriesAndDocuments } from '../../utils/firebase/firebase.utils';
import {
  fetchCategoriesSuccess,
  fetchCategoriesFailed,
} from './category.action';
import { CATEGORIES_ACTION_TYPES } from './category.types';

export function* fetchCategoriesAsync() {
  try {
    const categoriesArray = yield* call(
      getCatogoriesAndDocuments,
      'categories'
    ); // inside generator function we use '(yield*)' in place of '(await)' anywhere we have a function and we want turn it into an effect, we essentially use call() keyword. The call() fucntion takes two arguments, 1st is the callable function and 2nd is the argumnts passed to that 1st fucntion.
    yield* put(fetchCategoriesSuccess(categoriesArray)); // put() is used in place of dispatch() inside a generator function.
  } catch (error) {
    yield* put(fetchCategoriesFailed(error as Error));
  }
}

export function* onFetchCategories() {
  yield* takeLatest(
    // takeLatest() is where we receive actions, if it receives a bunch of same actions it returns the latest one. if we get the same actions let's say five times in a row before the generator function finish, it cancles the previous onesand restart with the latest one. it receives two arguments, the first is the 'action type' and the second argument is about what we actually want to happen
    CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_START,
    fetchCategoriesAsync
  );
}

export function* categoriesSaga() {
  yield* all([call(onFetchCategories)]);
}
